module.exports = __webpack_public_path__ + "img/icon4.66689244.png";